"use client";
import CardsList from "@/components/cardsList";
import { SOLUTIONS_CONSTANTS } from "./constants";

const SolutionComponent = () => {
  return (
    <CardsList
      columns={{ base: 1, md: 2 }}
      list={SOLUTIONS_CONSTANTS.list}
      spacing={{ base: 8, md: 20 }}
      title={SOLUTIONS_CONSTANTS.title}
      hoverEffect
      hover={{
        boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.2)",
        transform: "translateY(-5px) scale(1.02)",
        transition: "all 0.3s ease-in-out",
        background: "blue.50",
      }}
    />
  );
};

export default SolutionComponent;
